import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../../msalconfig';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    // Memoizar la instancia de MSAL para evitar recrearla en cada renderizado
    const msalInstance = useMemo(() => new PublicClientApplication(msalConfig), []);

    useEffect(() => {
        // Inicializar la instancia de MSAL
        msalInstance.initialize()
        .then(() => {
            // Limpiar el estado de interacción si hay una interacción pendiente
            msalInstance.handleRedirectPromise()
                .then(() => {
                    const account = msalInstance.getActiveAccount();
                    if (account) {
                        setIsAuthenticated(true);
                    }
                })
                .catch(error => {
                    console.error("Error handling redirect promise:", error);
                });
        })
        .catch(error => {
            console.error("MSAL initialization failed:", error);
        });
    }, [msalInstance]);

    const login = async () => {
        try {
            msalInstance.clearCache();

            const loginResponse = await msalInstance.loginRedirect();
            if (loginResponse.account) {
                setIsAuthenticated(true);

                /*
                
                window.opener = null; // Evita que el popup pueda acceder a la ventana principal
                window.open("", "_self"); // Abre una URL vacía en el popup
                window.close(); // Cierra el popup

                window.location.href = "/lista"; // Cambia "/lista" por la ruta deseada
                */
                
            }
        } catch (error) {
            console.error("Login failed:", error);
        }
    };

    const logout = () => {
        localStorage.removeItem('authToken');
        msalInstance.logout();
        setIsAuthenticated(false);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);